import { Observable, isObservable, of } from 'rxjs';

export function toObservable<T>(data: T | Observable<T>) {
  return isObservable(data) ? data : of(data);
}
